import { render } from "./Card.vue?vue&type=template&id=7c52fb48&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=7c52fb48&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\floresn\\source\\repos\\igx-vue-park-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c52fb48"]])

export default __exports__